import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RealmService {
  // private app: Realm.App;

  private msalInstance: IPublicClientApplication;

  constructor(
    @Inject('environment') private environment: any,
    private cookie: CookieService,
    private http: HttpClient
  ) {}

  public auth = {
    loginWithEmailPassword: (email, password): Promise<any> => {
      const payload = { provider: 'email-password', email, password };
      return this.http.post(`${this.environment.api}auth/login`, payload).toPromise();
    },

    createEmailCode: (email): Promise<any> => {
      const payload = { provider: 'email-code', email };
      return this.http.post(`${this.environment.api}auth/code`, payload).toPromise();
    },

    loginWithEmailCode: (email, code): Promise<any> => {
      const payload = { provider: 'email-code', email, code };
      return this.http.post(`${this.environment.api}auth/login`, payload).toPromise();
    },

    initializeMSAL: async (clientId: string) => {
      const msalConfig = {
        auth: { clientId },
      };

      this.msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
    },

    loginWithMicrosoft: async () => {
      const loginRequest = {
        scopes: ['user.read'],
        prompt: 'select_account',
      };

      const result = await this.msalInstance.loginPopup(loginRequest);

      const payload = {
        provider: 'microsoft',
        unique_id: result.uniqueId,
        email: result.account?.username,
        name: result.account?.name,
      };

      return this.http.post(`${this.environment.api}auth/login`, payload).toPromise();
    },

    openGoogleWindow: async (): Promise<any> => {
      const state = JSON.stringify({ provider: 'google' });
      const url = `https://accounts.google.com/o/oauth2/auth?client_id=${this.environment.google.clientId}&scope=openid%20profile%20email&redirect_uri=${this.environment.apps.auth}redirect&response_type=code&prompt=consent&state=${state}`;
      window.open(url, '_self');
    },

    loginWithGoogle: async (code: string): Promise<any> => {
      const result = await this.http
        .post<any>(`${this.environment.api}auth/openid`, { provider: 'google', code })
        .toPromise();

      const payload = {
        provider: 'google',
        ...result,
      };

      return this.http.post(`${this.environment.api}auth/login`, payload).toPromise();
    },

    registerWithEmail: (email, password): Promise<any> => {
      const payload = { provider: 'email-password', email, password };
      return this.http.post(`${this.environment.api}auth/register`, payload).toPromise();
    },

    resetPasswordWithEmail: (email): Promise<any> => {
      const payload = { email };
      return this.http.post(`${this.environment.api}auth/reset/send`, payload).toPromise();
    },

    resetPasswordConfirm: (token, password): Promise<any> => {
      const payload = { token, password };
      return this.http.post(`${this.environment.api}auth/reset`, payload).toPromise();
    },

    registerWithEmailConfirm: (token: string): Promise<any> => {
      const payload = { token };
      return this.http.post(`${this.environment.api}auth/confirm`, payload).toPromise();
    },

    // setApiKey: async (): Promise<void> => {
    //   const user: Realm.User = this.app.currentUser;
    //   const currentToken: string = this.cookie.get(`MaplixToken${this.environment.env}`);
    //   if (!currentToken) {
    //     const keys = await user.apiKeys.fetchAll();
    //     if (keys.length >= 10) {
    //       keys.sort((a, b) => {
    //         if (moment(a.name, 'DDMMYYYYHHmmss').diff(moment(b.name, 'DDMMYYYYHHmmss')) < 0) {
    //           return -1;
    //         } else if (moment(a.name, 'DDMMYYYYHHmmss').diff(moment(b.name, 'DDMMYYYYHHmmss')) === 0) {
    //           return -1;
    //         } else {
    //           return 1;
    //         }
    //       });
    //       await user.apiKeys.delete(keys[0]._id);
    //     }
    //     const apiKey = await user.apiKeys.create(moment().format('DDMMYYYYHHmmss'));
    //     this.cookie.set(`MaplixToken${this.environment.env}`, apiKey.key, 30, '/', this.environment.cookieDomain);
    //     this.cookie.set(`MaplixTokenId${this.environment.env}`, apiKey._id, 30, '/', this.environment.cookieDomain);
    //   }
    // },

    // removeApiKey: async (token): Promise<void> => {
    //   const credentials = Realm.Credentials.apiKey(token);
    //   const user: Realm.User = await this.app.logIn(credentials);
    //   const tokenId = this.cookie.get(`MaplixTokenId${this.environment.env}`);
    //   if (tokenId) {
    //     await user.apiKeys.delete(tokenId);
    //   }
    // },

    logout: () => {
      this.cookie.delete(`userDetails${this.environment.env}`, '/', this.environment.cookieDomain);
      this.cookie.delete(`activeWorkspace${this.environment.env}`, '/', this.environment.cookieDomain);
      this.cookie.delete(`MaplixToken${this.environment.env}`, '/', this.environment.cookieDomain);
      this.cookie.delete(`MaplixRefreshToken${this.environment.env}`, '/', this.environment.cookieDomain);
      location.href = `${this.environment.apps.auth}login`;
    },

    resendConfirmEmail: (email: string) => {
      const payload = { email };
      return this.http.post(`${this.environment.api}auth/confirm/send`, payload).toPromise();
    },
  };
}
